<template>
  <v-app :style="`background-color: ${$store.state.bgcolor}`" class="bblsans">
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",

  components: {},

  data: () => ({
    //
  }),
};
</script>
<style lang="css">
@font-face {
  font-family: "bblsans";
  src: url("./fonts/BBLSans-Regular.ttf") format("truetype");
  font-weight: normal;
}
@font-face {
  font-family: "bblsans";
  src: url("./fonts/BBLSans-Light.ttf") format("truetype");
  font-weight: 300;
}
@font-face {
  font-family: "bblsans";
  src: url("./fonts/BBLSans-Bold.ttf") format("truetype");
  font-weight: bold;
}

.bblsans {
  font-family: "bblsans", sans-serif !important;
}

.Montserrat {
  font-family: "Montserrat", sans-serif !important;
}

.Kanit {
  font-family: "Kanit", sans-serif !important;
}

.swal2-modal {
  font-family: "bblsans", "Montserrat", "Kanit", sans-serif !important;
}
</style>
